(() => {
  const home = document.querySelector('[data-anv-home]');
  if (!home) return;

  const header = home.querySelector('[data-anv-header]');
  const updateHeader = () => header?.classList.toggle('is-sticky', window.scrollY > 640);
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  home.querySelectorAll('a[href^="#anv-"]').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.open = false;
    });
  });

  const form = home.querySelector('#AnacotteValidationForm');
  if (form) {
    form.addEventListener('submit', () => {
      const submit = form.querySelector('button[type="submit"]');
      if (!submit) return;
      submit.disabled = true;
      submit.textContent = 'Sending project brief…';
    });
  }
})();
